module.exports = __webpack_public_path__ + "img/Newbie_Axe_04_Classic.0dd20a10.png";